export default __webpack_public_path__ + "static/media/completed-order-2.57f296c8.gif";